import { UAParser, UAParserInstance } from 'ua-parser-js';

import { Constants } from '../common/Constants';

export class DeviceContextData {
	uaParser: UAParserInstance;

	constructor(userAgent?: string) {
		this.uaParser = new UAParser(userAgent);
	}

	get deviceType(): string {
		const deviceType = this.uaParser.getDevice().type;
		if (deviceType) {
			if (/mobile/.test(deviceType.toLowerCase())) {
				return Constants.DEVICE.TYPE.PHONE;
			}
			if (/tablet/.test(deviceType.toLowerCase())) {
				return Constants.DEVICE.TYPE.TABLET;
			}
		}
		return Constants.DEVICE.TYPE.DESKTOP;
	}

	get orientationType(): string {
		if (window.matchMedia('(orientation: landscape)').matches) {
			return Constants.DEVICE.ORIENTATION.LANDSCAPE;
		}
		return Constants.DEVICE.ORIENTATION.PORTRAIT;
	}

	get operatingSystemName() {
		const osName = this.uaParser.getOS().name;
		if (osName) {
			if (/mac/.test(osName.toLowerCase())) {
				return Constants.DEVICE.OS_NAME.MAC;
			}
			if (/windows/.test(osName.toLowerCase())) {
				return Constants.DEVICE.OS_NAME.WINDOWS;
			}
			return osName;
		}
		return Constants.VALUE_NOT_AVAILABLE;
	}

	get browserName() {
		const browserName = this.uaParser.getBrowser().name;
		if (browserName) {
			if (/chrome/.test(browserName.toLowerCase())) {
				return Constants.DEVICE.BROWSER_NAME.CHROME;
			}
			if (/edge/.test(browserName.toLowerCase())) {
				return Constants.DEVICE.BROWSER_NAME.EDGE;
			}
			if (/firefox/.test(browserName.toLowerCase())) {
				return Constants.DEVICE.BROWSER_NAME.FIREFOX;
			}
			if (/safari/.test(browserName.toLowerCase())) {
				return Constants.DEVICE.BROWSER_NAME.SAFARI;
			}
			if (/ie/.test(browserName.toLowerCase())) {
				return Constants.DEVICE.BROWSER_NAME.IE;
			}
			if (/opera/.test(browserName.toLowerCase())) {
				return Constants.DEVICE.BROWSER_NAME.OPERA;
			}
			return browserName;
		}
		return Constants.VALUE_NOT_AVAILABLE;
	}
}
